import Country from './Country';
import Header from './Header';
import React from 'react';
import Sticky from 'react-stickynode';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import intersection from 'lodash/intersection';

export const getEligibleCountries = (vaccination, priorityGroups) => {
  const priorityGroupCountries = priorityGroups.map(pg => pg.country.isoAlpha2);
  const vaccinationCountries = vaccination
    .filter(c => c.peopleVaccinated)
    .map(c => c.countryISO);
  const countries = intersection(priorityGroupCountries, vaccinationCountries).map((isoAlpha2) => {
    const vaccinationStats = vaccination.find(d => d.countryISO === isoAlpha2);
    return {
      isoAlpha2,
      vaccinationStats,
      priorityGroups: priorityGroups.find(d => d.country.isoAlpha2 === isoAlpha2),
      vaccinatedPercentOfPop: vaccinationStats.peopleVaccinated / vaccinationStats.population,
    };
  });
  // Sort by greatest percent of pop vaccinated
  countries.sort((a, b) => b.vaccinatedPercentOfPop - a.vaccinatedPercentOfPop);
  return countries;
};

const PriorityGroups = (props) => {
  const {
    globalStatistics,
    vaccinationSummaryStatistics,
    priorityGroupsSummaryStatistics,
  } = props;

  const countries = getEligibleCountries(vaccinationSummaryStatistics, priorityGroupsSummaryStatistics);

  return (
    <section id='priority-groups-section' className={classnames(component, 'wide')}>
      <Sticky top={0} bottomBoundary='#priority-groups-section'>
        <Header />
      </Sticky>

      {countries.map((country) => (
        <Country {...country} globalStatistics={globalStatistics} key={country.isoAlpha2} />
      ))}
      <div />
    </section>
  );
};

export default PriorityGroups;
